/*
 * @Description: 表格
 * @Author: shangao
 * @Date: 2022-04-26 14:23:59
 * @LastEditTime: 2022-05-06 10:26:26
 * @LastEditors: shangao
 * @FilePath: \teaching-web\src\components\Table.jsx
 */
import { axiosFactory } from '@/services/axios-factory'
const TableProps = {
  url: { type: String },
  columns: { type: Array },
  formData: { type: Object },
  indexNo: { type: Boolean, default: true },
  rowSelection: { type: Object }
}

const Table = {
  name: 'MTable',
  props: TableProps,
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      dataSource2: [],
      selectedRows: []
    }
  },
  watch: {
    formData: function () {
      this.axiosList(1)
    }
  },
  created () {
    this.axiosList(1)
  },
  methods: {
    // 获取表格数据
    async axiosList (currentPage) {
      const { url, indexNo, formData } = this.$props
      const { pageSize } = this.$data
      const params = { pageNum: currentPage, pageSize, ...formData }
      try {
        this.loading = true
        const { data } = await axiosFactory({ url, params })
       
      
        if (indexNo) {
          const baseNum = (currentPage - 1) * pageSize
          data.list.forEach((item, index) => {
            item.indexNo = baseNum + index + 1
          })
        }
       
        this.dataSource2 = data.list;
        const result = [];
         if(url=='live/listLiveCourse'){  
          this.dataSource2.forEach(item => {
            let obj = Object.assign({}, item);
            obj['allviewCount'] = (item.viewCount+item.resViewCount) *1;
            result.push(obj); 
          })
          this.dataSource2=result;
        }
        this.currentPage = currentPage
        this.total = Number(data.total)
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    // handleSelectionChange (selectedRows) {
    //   this.selectedRows = selectedRows
    // },
    // 重新加载表格：operation(create,update,delete)
    reload (operation) {
      let { currentPage } = this.$data
      if (operation === 'create') {
        currentPage = 1
      } else if (operation === 'delete' && this.dataSource2.length === 1) {
        currentPage = currentPage > 1 ? currentPage-- : 1
      }
      this.axiosList(currentPage)
    }
  },
  render () {
    const { columns, rowSelection, indexNo } = this.$props
    const { loading, dataSource2, currentPage, pageSize, total } = this.$data
    // 多选
    const selectionColumn = rowSelection && <el-table-column type="selection" width="55" selectable={rowSelection.selectable} />
    const indexColumn = indexNo && <el-table-column label="序号" prop="indexNo" width="50" />
    const selectionChange = rowSelection ? rowSelection.onChange : () => { }

    // 列
    const renderColumn = (item) => {
      const data = { attrs: { ...item } }
      if (item.scopedSlots && item.scopedSlots in this.$scopedSlots) {
        data.scopedSlots = { default: this.$scopedSlots[item.scopedSlots] }
      } else {
        data.scopedSlots = {
          default: ({ row }) => {
            const text = row[item.prop]
            return <div class="ell" title={text}>{text}</div>
          }
        }
        // data.attrs.showOverflowTooltip = true
      }
      return <el-table-column {...data} />
    }
    return (
      <div class="m-table">
        <el-table vLoading={loading} data={dataSource2} onselection-change={selectionChange}>
          {selectionColumn}
          {indexColumn}
          {columns.map(item => renderColumn(item))}
        </el-table>
        <el-pagination
          background
          hide-on-single-page
          total={total}
          page-size={pageSize}
          current-page={currentPage}
          layout="total, prev, pager, next"
          onCurrent-change={this.axiosList} />
      </div>
    )
  }
}

export default Table